import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MemberService } from '../../services/jrni/member.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../_alert';
import { ServicesService } from '../../services/jrni/services.service';
import { _, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { QuestionsService } from '../../services/questions.service';
import { ConfigService } from '../../services/config.service';
import {
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import * as he from 'he';
import moment from 'moment';
import { ApiService } from '../../services/jrni/api.service';
import { CommonFunctionsService } from '../../services/common-functions.service';
import { AppConfig } from '../../app.config';
import { inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeadingComponent } from '@bookinglab/govbook-ui/layout';
import {
	InfoBoxComponent,
	WarningBoxComponent,
} from '@bookinglab/westminster-ui';
import { StepperComponent } from '@bookinglab/ui';
import { FormErrorMessagesComponent } from '../../form-error-messages/form-error-messages.component';
import { postcodeValidator } from "../../validators/postcode.validator";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormBuilderComponent, FormBuilderService as LibFormBuilderService } from '@bookinglab/ui';

@Component({
	selector: 'app-services',
	standalone: true,
	templateUrl: './services.component.html',
	styleUrls: ['./services.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		PageHeadingComponent,
		TranslatePipe,
		InfoBoxComponent,
		WarningBoxComponent,
		StepperComponent,
		FormErrorMessagesComponent,
		MatAutocompleteModule,
		FormBuilderComponent,
	],
})
export class ServicesComponent implements OnInit {
	private core = AppConfig.settings.core;
	selectedDepartment;
	pageTitle;
	servicePageText;
	servicesList;
	filteredServiceList: any;
	selectedService;
	selectedResource;
	companyQuestions = [];
	suggestions: any;
	location;
	guidanceText;
	submitted = false;
	invalidInitForm: any;
	showServices = false;
	answeredQuestions = [false, false, false];
	config: any;
	showContinueButton = false;
	loadedConfig = false;
	// move to config soon
	ceramony_options = [{ option: 'Yes' }, { option: 'No' }];
	ageType = '';
	compQuestions = [];
	addresses: any;
	showingAddresses: boolean;
	companyId: any;
	debounceTimer: any;
	skipLocations: any;
	locations: any;
	selectedLocation: any;
	autoSetLocation = false;
	searchText = '';
	setCompanyFromQuestion: any;
	adminOnlyJourney: any;
	showOther: any;
	lookupError: any;
	journey = 'default';
	returnConfig: any;
	agentMode: any;
	citizenshipExpired = false;
	checkedLookups = [];
	formData: any = [];
	selectedFormId = '';
	showFormBuilder = true;
	serviceToSet: any;
	resourceToSet: any;
	staffToSet: any;

	steps = [
		{ title: 'Booking questions', isActive: true },
		{ title: 'Choose appointment date and time', isActive: false },
		{ title: 'Your details', isActive: false },
		{ title: 'Summary', isActive: false },
		{ title: 'Confirmation', isActive: false },
	];

	formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
	libFormBuilderService = inject(LibFormBuilderService);
	constructor(
		private departmentService: DepartmentService,
		private router: Router,
		protected alertService: AlertService,
		private servicesService: ServicesService,
		private cdref: ChangeDetectorRef,
		private spinner: NgxSpinnerService,
		public datastoreService: DatastoreService,
		private memberService: MemberService,
		private availabilityService: AvailabilityService,
		private questionsService: QuestionsService,
		public translateService: TranslateService,
		public configService: ConfigService,
		private apiService: ApiService,
		private route: ActivatedRoute,
		public commonFunctions: CommonFunctionsService
	) {
		this.appConfig = this.apiService.getAppConfig();
	}

	appConfig;

	companyQuestionsForm: UntypedFormGroup = this.formBuilder.group({});

	initQuestions: UntypedFormGroup = new UntypedFormGroup({
		type_of_appointment: new UntypedFormControl('', Validators.required),
	});

	get form() {
		return this.companyQuestionsForm.controls;
	}

	formReady($event: Record<string, any>) {
		if ($event.form_id === this.selectedFormId) {
			console.log(`Form ready event received in ServicesComponent: ${$event.form_id}`);
			console.log('resetting calculation duration before storing schema');
			this.datastoreService.extraDuration = 0;
		}
	}

	async onExtraItemSet($event: Record<string, any>) {
		console.log(`Extra item set event received in ServicesComponent: `, $event);
		if ($event.item) {
			console.log(`Adding extra item fee for extra item: `, $event.item);
			// Remove stale entry for same field before pushing (prevents duplicate
			// accumulation when user toggles between mutually exclusive options).
			const staleIdx = this.datastoreService._extraItems.findIndex(
				(item: any) => item.field === $event.item.field
			);
			if (staleIdx !== -1) {
				this.datastoreService._extraItems.splice(staleIdx, 1);
			}
			this.datastoreService._extraItems.push($event.item);
		}
		else {
			// Match by field name — item_id in the event is the schema UUID, not the
			// numeric API id stored on _extraItems entries, so it would never match.
			const fieldName = $event.field;
			const key = fieldName
				? this.datastoreService._extraItems.findIndex((item: any) => item.field === fieldName)
				: this.datastoreService._extraItems.findIndex((item: any) => String(item.item_id) === String($event.item_id));
			console.log(`Removing extra item fee for field: ${fieldName} at index ${key}`);
			if (key > -1) {
				this.datastoreService._extraItems.splice(key, 1);
			}
		}
		console.log('this.datastoreService._extraItems', this.datastoreService._extraItems);
	}

	async onCompanySet($event: string) {
		this.setCompanyFromQuestion = $event;
		let location;
		const locations = await this.selectedDepartment.$getChildren();
		for (const c of locations) {
			if (c.id == $event) {
				location = c;
				break;
			}
		}
		console.log(`Location set event received in ServicesComponent: ${$event}`, location);
		if (location) {
			this.selectedLocation = location;
			this.datastoreService.selectedLocation = location;
			await this.departmentService.setLocation(location);
		}
	}

	async onServiceSet($event: string) {
		let service;
		const services = await this.selectedDepartment.$getServices();
		for (const s of services) {
			if (s.id == $event) {
				service = s;
				break;
			}
		}

		this.serviceToSet = service;
		this.selectedService = service;
		this.servicesService.selectedService = service;
	}

	async onResourceSet($event: string) {
		console.log(`Resource set event received in ServicesComponent: ${$event}`);
		this.resourceToSet = $event;
	}

	async onStaffSet($event: string) {
		console.log(`Staff set event received in ServicesComponent: ${$event}`);
		this.staffToSet = $event;
		this.datastoreService.staff_set = $event;
	}

	async onAddDuration($event: string) {
		console.log(`Add duration event received in ServicesComponent: ${$event}`);
		this.datastoreService.extraDuration =
			Number(this.datastoreService.extraDuration) +
			Number($event);
		console.log(
			`Adding duration: ${$event} - total extra is now ${this.datastoreService.extraDuration}`
		);
	}

	async onAddressSet($event: any, field) {
		console.log(`Address set event received in ServicesComponent:`, $event);
		const selectedAddress = $event
		this.datastoreService.selectedAddress = selectedAddress;
	}

	onUpdateDatastore(event: any): void {
		console.log('Update datastore event received in ServicesComponent:', event);
		if (event.type === 'lookupResponse' && event.lookupResponse) {
			this.datastoreService.lookupResponses.push(event.lookupResponse);
			console.log('Lookup response added to datastore:', event.lookupResponse);
		}
		// Store booker fields for auto-fill on booking-details page
		const bookerKeys = ['booker_first_name', 'booker_last_name', 'booker_email', 'booker_phone'];
		for (const key of bookerKeys) {
			if (event[key] !== undefined) {
				this.datastoreService[key] = event[key];
			}
		}
	}

	decodeHtmlEntities(text) {
		const entities = {
			'&amp;': '&',
			'&lt;': '<',
			'&gt;': '>',
			'&quot;': '"',
			'&#39;': "'",
		};
		return text.replace(
			/&amp;|&lt;|&gt;|&quot;|&#39;/g,
			(match) => entities[match]
		);
	}

	validateAppointmentTypeQuestion(event?: Event) {
		this.invalidInitForm = undefined;

		const selectedSchema = this.initQuestions.get('type_of_appointment')?.value;

		// existing logic
		if (selectedSchema === 'admin-citizenship') {
			window.location.href = `/start/citizenship?admin-only=true&auth_token=${localStorage.getItem(
				'auth_token'
			)}`;
			return;
		}

		if (selectedSchema === 'admin-certificate') {
			window.location.href = `/start/order_a_copy_certificate?admin-only=true&auth_token=${localStorage.getItem(
				'auth_token'
			)}`;
			return;
		}

		this.selectedFormId = selectedSchema;
		this.datastoreService.selectedSchema = selectedSchema;

		this.forceRecreateFormBuilder();
	}

	forceRecreateFormBuilder() {
		this.showFormBuilder = false;
		setTimeout(() => (this.showFormBuilder = true));
	}

	// Number input text validation, keycode 8 is backspace
	keyPressNumberField(event: any) {
		const pattern = /[0-9\+\-\ ]/;
		const inputChar = String.fromCharCode(event.charCode);
		if (event.keyCode != 8 && !pattern.test(inputChar)) {
			event.preventDefault();
		}
	}

	allowOnlyNumbers(event: KeyboardEvent) {
		const key = event.key;
		if (
			!/^[0-9]$/.test(key) &&
			key !== 'Backspace' &&
			key !== 'Tab' &&
			key !== 'ArrowLeft' &&
			key !== 'ArrowRight'
		) {
			event.preventDefault();
		}
	}

	// validate future dates
	futureDateValidator(control) {
		const currentDate = new Date();
		const inputDate = new Date(control.value);
		if (control.value) {
			if (inputDate > currentDate) {
				return { futureDate: true };
			}
			return null;
		} else {
			return null;
		}
	}

	// validate past dates
	pastDateValidator(control) {
		const currentDate = new Date();
		const inputDate = new Date(control.value);
		if (control.value) {
			if (inputDate < currentDate) {
				return { pastDate: true };
			}
			return null;
		} else {
			return null;
		}
	}

	// validate past dates but not older than 1 year
	lessThanOneYearOldValidator(control) {
		if (!control.value) return null;

		const currentDate = new Date();
		const inputDate = new Date(control.value);

		// normalize to midnight for all comparisons
		inputDate.setHours(0, 0, 0, 0);
		currentDate.setHours(0, 0, 0, 0);

		// go back exactly 365 days
		const cutoffDate = new Date(currentDate);
		cutoffDate.setDate(cutoffDate.getDate() - 365);

		if (inputDate < cutoffDate) {
			return { olderThanOneYear: true };
		}

		return null;
	}

	// the "SCHEMA"
	/** */
	onQuestionChange($event: any = null, question: any = null): void {
		console.log(`old schema question change triggered`);
		this.showServices = false;
		// this.datastoreService.extraDuration = 0; // reset or we add more on everytime
		const bookingQuestions = this.companyQuestions;
		// Conditional questions logic
		// for (let index = 0; index < bookingQuestions.length; index++) {
		/**
		bookingQuestions.forEach(async (bookingQuestion: any) => {
			bookingQuestion.visible = false; // reset any questions that shouldnt be visible
			// go get the answer for every question from the form
			const control = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
			bookingQuestion.answer = undefined;
			if (control) {
				// set booking question from form values
				bookingQuestion.answer = control.value ? control.value : undefined;
			}

			if (bookingQuestion['help_text']) {
				bookingQuestion.conditionals = JSON.parse(bookingQuestion['help_text']); // to change to settings block soon...
				if (bookingQuestion.conditionals.hasOwnProperty('help_text')) {
					bookingQuestion.helptext = bookingQuestion.conditionals.help_text;

					let linkPattern = /#(.*?)#/g;
					if (linkPattern.test(bookingQuestion.helptext)) {
						bookingQuestion.helptext = bookingQuestion.helptext.replace(
							linkPattern,
							function (match, p1) {
								return (
									`<a href="${bookingQuestion.conditionals.hyperlink}" target="_blank">` +
									p1 +
									'</a>'
								);
							}
						);
					}

					let tildePattern = /~(.*?)~/g;
					if (tildePattern.test(bookingQuestion.helptext)) {
						bookingQuestion.helptext = bookingQuestion.helptext.replace(
							tildePattern,
							(match, p1) => {
								const decoded = this.decodeHtmlEntities(p1);
								return `<a ${decoded}</a>`;
							}
						);
					}

					if (
						tildePattern.test(bookingQuestion.conditionals['component_text'])
					) {
						bookingQuestion.conditionals['component_text'] =
							bookingQuestion.conditionals['component_text'].replace(
								tildePattern,
								(match, p1) => {
									const decoded = this.decodeHtmlEntities(p1);
									return `<a ${decoded}</a>`;
								}
							);
					}
				}

				// these should be dynamic if need to add more to just add EVERY conditional to the bookingQuestion object
				if (
					bookingQuestion.conditionals.component_type == 'file-upload' &&
					bookingQuestion.detail_type == 'text_area'
				) {
					bookingQuestion.base64upload = true;
				}
				if (
					bookingQuestion.conditionals.hasOwnProperty('question-font-colour')
				) {
					bookingQuestion.customLabelColour =
						bookingQuestion.conditionals['question-font-colour'];
				}
				if (bookingQuestion.conditionals.hasOwnProperty('filter_by')) {
					bookingQuestion.filter_by = bookingQuestion.conditionals['filter_by'];
				}

				if (
					bookingQuestion.conditionals.hasOwnProperty(
						'cap_calendar_dates_one_year_from_entered_date'
					)
				) {
					bookingQuestion.cap_calendar_dates_one_year_from_entered_date = true;
				}

				if (bookingQuestion.conditionals.hasOwnProperty('lookup')) {
					bookingQuestion.aws_lookup = true;
					bookingQuestion.aws_table =
						bookingQuestion.conditionals['lookup'].aws_table;
					bookingQuestion.field = bookingQuestion.conditionals['lookup'].field;
					bookingQuestion.lookup_field =
						bookingQuestion.conditionals['lookup'].question_id;
				}

				if (bookingQuestion.conditionals.hasOwnProperty('question_reference')) {
					bookingQuestion.question_reference =
						bookingQuestion.conditionals['question_reference'];
				}

				if (
					bookingQuestion.conditionals.hasOwnProperty(
						'citizenship_fees_table_show'
					)
				) {
					bookingQuestion.citizenship_fees_table_show = true;
				}

				// specific conditions
				if (bookingQuestion.conditionals.hasOwnProperty('address_lookup')) {
					if (
						bookingQuestion.conditionals['address_lookup'] === 'yes' ||
						bookingQuestion.conditionals['address_lookup'] === 'true'
					) {
						bookingQuestion.address_lookup = true;
					}
				}
				if (bookingQuestion.conditionals.hasOwnProperty('resource_lookup')) {
					if (
						bookingQuestion.conditionals['resource_lookup'] === 'yes' ||
						bookingQuestion.conditionals['resource_lookup'] === 'true'
					) {
						bookingQuestion.resource_lookup = true;
						bookingQuestion.selected_resource = undefined;
					}
				}
				if (
					bookingQuestion.conditionals.hasOwnProperty(
						'company_and_resource_set'
					)
				) {
					if (
						bookingQuestion.conditionals['company_and_resource_set'] ===
						'yes' ||
						bookingQuestion.conditionals['company_and_resource_set'] === 'true'
					) {
						bookingQuestion.company_and_resource_set = true;
						this.autoSetLocation = true;
					}
				}

				if (bookingQuestion.conditionals.hasOwnProperty('validation')) {
					if (!this.config.validation) {
						// if there is no validation on the root
						// its probably under the journey_config
						this.config.validation =
							this.config.journey_config?.appointments?.validation;
					}

					try {
						if (
							this.config.validation[bookingQuestion.conditionals.validation]
						) {
							bookingQuestion.validation =
								this.config.validation[bookingQuestion.conditionals.validation];
							bookingQuestion.validation_message =
								bookingQuestion.conditionals.validation_message;
							let validators = [Validators.pattern(bookingQuestion.validation)];
							if (bookingQuestion.required) {
								validators.push(Validators.required);
							}
							control.setValidators(validators);
							this.companyQuestionsForm.updateValueAndValidity();
						} else {
							if (bookingQuestion.conditionals.validation == 'email') {
								bookingQuestion.validation = 'email';
								bookingQuestion.validation_message =
									bookingQuestion.conditionals.validation_message;
								let validators = [];

								validators.push(
									Validators.pattern(
										/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
									)
								);

								if (bookingQuestion.required) {
									validators.push(Validators.required);
								}

								control.setValidators(validators);
								this.companyQuestionsForm.updateValueAndValidity();
							}
							if (bookingQuestion.conditionals.validation == 'postcode') {
								bookingQuestion.validation = 'postcode';
								bookingQuestion.validation_message =
									bookingQuestion.conditionals.validation_message;
								let validators = [postcodeValidator()];
								if (bookingQuestion.required) {
									validators.push(Validators.required);
								}
								control.setValidators(validators);
								this.companyQuestionsForm.updateValueAndValidity();
							}
						}
					} catch (error) {
						console.warn(
							`There was an error setting config for ${bookingQuestion.id}`
						);
						console.log(error);
					}
				} else {
					if (bookingQuestion.required) {
						control.setValidators(Validators.required);
					}
				}

				if (bookingQuestion.conditionals.hasOwnProperty('section_title')) {
					if (bookingQuestion.conditionals.section_title) {
						bookingQuestion.detail_type = 'heading_2';
					}
				}

				if (bookingQuestion.detail_type === 'date') {
					bookingQuestion.hide_dates_in_future = false;
					bookingQuestion.hide_dates_in_past = false;
					bookingQuestion.less_than_one_year_old = false;
					let validators = [];

					if (
						bookingQuestion.conditionals.hasOwnProperty(
							'hide_dates_in_future'
						) &&
						bookingQuestion.conditionals.hide_dates_in_future
					) {
						bookingQuestion.hide_dates_in_future =
							moment().format('YYYY-MM-DD');
						// future date
						if (bookingQuestion.hide_dates_in_future) {
							if (bookingQuestion.required) {
								validators.push(Validators.required);
							}
							validators.push(this.futureDateValidator);
							control.setValidators(validators);
							control.updateValueAndValidity();
							this.companyQuestionsForm.updateValueAndValidity();
						}
					}

					if (
						bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_past') &&
						bookingQuestion.conditionals.hide_dates_in_past
					) {
						bookingQuestion.hide_dates_in_past = moment().format('YYYY-MM-DD');

						// past date
						if (bookingQuestion.hide_dates_in_past) {
							if (bookingQuestion.required) {
								validators.push(Validators.required);
							}
							validators.push(this.pastDateValidator);
							control.setValidators(validators);
							control.updateValueAndValidity();
							this.companyQuestionsForm.updateValueAndValidity();
						}
					}

					if (
						bookingQuestion.conditionals.hasOwnProperty(
							'less_than_one_year_old'
						) &&
						bookingQuestion.conditionals.less_than_one_year_old
					) {
						bookingQuestion.less_than_one_year_old =
							moment().format('YYYY-MM-DD');

						// date no older than one year
						if (bookingQuestion.less_than_one_year_old) {
							if (bookingQuestion.required) {
								validators.push(Validators.required);
							}
							validators.push(this.lessThanOneYearOldValidator);
							control.setValidators(validators);
							control.updateValueAndValidity();
							this.companyQuestionsForm.updateValueAndValidity();
						}
					}
				}

				if (this.config['auto_select_service']) {
					if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
						this.servicesList.forEach((service: any) => {
							if (`${service.id}` == bookingQuestion.conditionals.service_set) {
								// service set log in orange
								console.log(
									`%cAuto-selecting 'service_set' service: ${service.name}`,
									'color: orange;'
								);
								this.selectService(service);
							}
						});
					}
				}

				const conditionals = bookingQuestion.conditionals;
				let show = conditionals.show;
				const hide = conditionals.hide;
				const admin_show = conditionals.admin_show;
				let admin_only = conditionals.admin_only;

				// if the booking is only for the admin journey
				if (admin_only && this.datastoreService.adminJourney) {
					show = admin_show;
					admin_only = false;
				}

				if (
					Object.keys(show).length === 0 &&
					Object.keys(hide).length === 0 &&
					!conditionals.admin_only
				) {
					// no hide or show conditional values, just show the question by default
					bookingQuestion.visible = true;
				}

				// show condition loop
				for (const answerId in show) {
					if (answerId == 'hide') {
						return; // this shouldnt happen only if the setup is wrong
					}
					if (answerId === 'custom') {
						const conditions = show[answerId];

						for (const [questionKey, condition] of Object.entries(conditions)) {
							const conditionalQuestion =
								this.companyQuestionsForm.get(questionKey);

							if (
								conditionalQuestion &&
								conditionalQuestion.value != null &&
								((typeof conditionalQuestion.value === 'string' &&
									conditionalQuestion.value.trim().length > 0) ||
									(Array.isArray(conditionalQuestion.value) &&
										conditionalQuestion.value.length > 0))
							) {
								const isOrCondition =
									typeof condition === 'string' && condition.includes('OR');
								const isVisible = isOrCondition
									? this.evaluateORCondition(
										condition,
										conditionalQuestion.value
									)
									: this.evaluateCondition(
										condition,
										conditionalQuestion.value
									);

								if (isVisible) {
									bookingQuestion.visible = true;
									break; // stop evaluating once one condition passes
								}
							}
						}
					} else if (answerId == 'custom_multiple_condition') {
						// https://bookinglab.atlassian.net/browse/RWRSPI-376
						const conditionSet = show[answerId]?.conditions;

						if (Array.isArray(conditionSet)) {
							let allConditionsMet = true;

							for (const conditionEntry of conditionSet) {
								const [questionKey, expectedValue] =
									Object.entries(conditionEntry)[0];
								const conditionalQuestion =
									this.companyQuestionsForm.get(questionKey);
								const actualValue = conditionalQuestion?.value;

								// does the conditional question have errors
								if (conditionalQuestion?.errors) {
									console.warn(
										`Conditional question ${questionKey} has errors:`,
										conditionalQuestion.errors
									);
									allConditionsMet = false;
									break;
								}

								const isValuePresent =
									actualValue != null &&
									((typeof actualValue === 'string' &&
										actualValue.trim().length > 0) ||
										(Array.isArray(actualValue) && actualValue.length > 0));

								if (expectedValue === '*') {
									if (!isValuePresent) {
										allConditionsMet = false;
										break;
									}
								} else {
									let conditionMet = false;

									// like 1 OR 2
									if (
										typeof expectedValue === 'string' &&
										expectedValue.includes('OR')
									) {
										conditionMet = this.evaluateORCondition(
											expectedValue,
											actualValue
										);
									} else {
										// none or condition
										if (
											isValuePresent &&
											((typeof actualValue === 'string' &&
												actualValue === expectedValue) ||
												(Array.isArray(actualValue) &&
													actualValue.includes(expectedValue)))
										) {
											conditionMet = true;
										}
									}

									if (!conditionMet) {
										allConditionsMet = false;
										break;
									}
								}
							}

							if (allConditionsMet) {
								bookingQuestion.visible = true;
							}
						}
					} else if (answerId === 'custom_or_condition') {
						// https://bookinglab.atlassian.net/browse/RWRSPI-382
						const conditionSet = show[answerId]?.conditions;

						if (Array.isArray(conditionSet)) {
							for (const conditionEntry of conditionSet) {
								const [questionKey, acceptedAnswers] = Object.entries(
									conditionEntry
								)[0] as any;

								const conditionalQuestion =
									this.companyQuestionsForm.get(questionKey);
								const actualValue = conditionalQuestion?.value;

								if (
									actualValue != null &&
									((typeof actualValue === 'string' &&
										acceptedAnswers.includes(actualValue)) ||
										(Array.isArray(actualValue) &&
											actualValue.some((val) => acceptedAnswers.includes(val))))
								) {
									console.log(
										`%cCondition for custom_or_condition met for question ${questionKey} with value: ${actualValue}`,
										'color: green;'
									);
									bookingQuestion.visible = true;
									break; // One match is enough
								}
							}
						}
					} else if (answerId === 'address') {
						Object.keys(show['address']).forEach((key) => {
							const conditionalQuestion = this.companyQuestionsForm.get(
								`${key}`
							);

							if (conditionalQuestion && conditionalQuestion.value !== null) {
								// to check if its answered
								// find the key in the this.bookingQuestions array
								// const bookingQuestionKey = Number(
								// 	Object.keys(bookingQuestion.conditionals.show.address)[0]
								// );

								console.log(`checking address conditional for question ${key}`);
								const currentQuestion = bookingQuestions.findIndex(
									(q) => q.id == key
								);
								const addressLookupQuestion = bookingQuestions[currentQuestion];

								if (
									addressLookupQuestion.eligible_address[key] ==
									bookingQuestion.conditionals.show.address[key]
								) {
									bookingQuestion.visible = true;
								}
							}
						});
					} else if (answerId === 'custom_all_lookups_successful') {
						// check every lookup question
						const lookupQuestions = bookingQuestions.filter(
							(q) => q.aws_lookup && q.visible
						);

						// if there are no lookup questions, we can skip this
						if (lookupQuestions.length === 0) {
							bookingQuestion.visible = false;
							return;
						}

						// if any of the lookupQuestions contain lookupError = true or lookupUsed = true and all have an answer then bookingQuestion.visible = false
						const allLookupsSuccessful = lookupQuestions.every(
							(q) =>
								!q.lookupError &&
								!q.lookupUsed &&
								q.answer != null &&
								q.answer !== ''
						);

						// do any of the lookup fields have errors?
						const lookupFieldsWithErrors = lookupQuestions.some(
							(q) => this.companyQuestionsForm.get(`${q.id}`).errors
						);

						if (lookupFieldsWithErrors) {
							bookingQuestion.visible = false;
						} else {
							bookingQuestion.visible = true;
						}

						if (allLookupsSuccessful) {
							bookingQuestion.visible = true;
						} else {
							bookingQuestion.visible = false;
						}
					} else {
						// if this is an admin journey, and there is an admin show value
						if (this.datastoreService.adminJourney && admin_show) {
							// if we find a show in both
							if (admin_show[`${answerId}`] && show[`${answerId}`]) {
								// set the show to the admin version as it supersedes show
								show[`${answerId}`] = admin_show[`${answerId}`];
								bookingQuestion.admin_override = true;
							}
						}

						const conditionalQuestion = this.companyQuestionsForm.get(
							`${answerId}`
						);

						if (conditionalQuestion && conditionalQuestion.value != null) {
							if (
								conditionalQuestion.value ||
								conditionalQuestion.value.length > 0
							) {
								if (show[answerId].trim() == '*') {
									// wild card
									if (
										conditionalQuestion.value ||
										conditionalQuestion.value.length > 0
									) {
										// if there is any answer
										bookingQuestion.visible = true;
									}
								} else {
									if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
										bookingQuestion.visible = true;
									}
								}
							}
						}
					}
				}

				// perform hide after show because we want it to take priority
				for (const answerId in hide) {
					if (answerId == 'show') {
						return; // this shouldnt happen only if the setup is wrong
					}
					if (answerId === 'custom') {
						const conditions = hide[answerId];

						for (const [questionKey, condition] of Object.entries(conditions)) {
							const conditionalQuestion =
								this.companyQuestionsForm.get(questionKey);

							if (
								conditionalQuestion &&
								conditionalQuestion.value != null &&
								((typeof conditionalQuestion.value === 'string' &&
									conditionalQuestion.value.trim().length > 0) ||
									(Array.isArray(conditionalQuestion.value) &&
										conditionalQuestion.value.length > 0))
							) {
								const isOrCondition =
									typeof condition === 'string' && condition.includes('OR');
								const isVisible = isOrCondition
									? this.evaluateORCondition(
										condition,
										conditionalQuestion.value
									)
									: this.evaluateCondition(
										condition,
										conditionalQuestion.value
									);

								if (isVisible) {
									bookingQuestion.visible = true;
									break; // stop evaluating once one condition passes
								}
							}
						}
					} else {
						const conditionalQuestion = this.companyQuestionsForm.get(
							`${answerId}`
						);
						if (conditionalQuestion && conditionalQuestion.value != null) {
							if (
								conditionalQuestion.value ||
								conditionalQuestion.value.length > 0
							) {
								if (show[answerId] == '*') {
									// wild card
									if (
										conditionalQuestion.value ||
										conditionalQuestion.value.length > 0
									) {
										// if there is any answer
										bookingQuestion.visible = true;
									}
								} else {
									if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
										bookingQuestion.visible = false;
									}
								}
							}
						}
					}
				}

				// copy question schema
				if (bookingQuestion.visible) {
					if (bookingQuestion.conditionals.hasOwnProperty('copy_data')) {
						bookingQuestion.copy_data_from =
							bookingQuestion.conditionals['copy_data'].from;
						bookingQuestion.copy_data_to =
							bookingQuestion.conditionals['copy_data'].to;

						if (bookingQuestion.answer) {
							bookingQuestion.copy_data_from.forEach((fromId, index) => {
								const toId = bookingQuestion.copy_data_to[index];
								const sourceControl = this.companyQuestionsForm.get(
									String(fromId)
								);
								const targetControl = this.companyQuestionsForm.get(
									String(toId)
								);
								if (sourceControl && targetControl) {
									targetControl.setValue(sourceControl.value);
								} else {
									console.warn(
										`Control not found for: ${fromId} or target: ${toId}`
									);
								}
							});
						}
					}
				}

				// set company from question
				if (bookingQuestion.visible) {
					if (bookingQuestion.conditionals.hasOwnProperty('set_company')) {
						this.setCompanyFromQuestion =
							bookingQuestion.conditionals['set_company'];
					}
				} else {
					if (bookingQuestion.conditionals.hasOwnProperty('set_company')) {
						this.setCompanyFromQuestion = false;
					}
				}

				// add hidden field
				if (bookingQuestion.conditionals.hasOwnProperty('hidden_field')) {
					bookingQuestion.hidden = true;
				}

				// add duration schema
				if (bookingQuestion.visible) {
					if (bookingQuestion.conditionals.hasOwnProperty('add_duration')) {
						this.datastoreService.extraDuration =
							Number(this.datastoreService.extraDuration) +
							Number(bookingQuestion.conditionals.add_duration);
						console.log(
							`Adding duration from question (${bookingQuestion.id}): ${bookingQuestion.conditionals.add_duration} - total extra is now ${this.datastoreService.extraDuration}`
						);
					}
				}

				if (bookingQuestion.visible) {
					if (bookingQuestion.conditionals.hasOwnProperty('appointment_type')) {
						bookingQuestion.appointment_type =
							bookingQuestion.conditionals['appointment_type'];
						this.datastoreService.appointment_type =
							bookingQuestion.conditionals['appointment_type'];
						console.log(
							`Setting appointment_type from question (${bookingQuestion.id}): ${bookingQuestion.conditionals['appointment_type']}`
						);
					}
				}

				// set sevice/resource question to var
				if (bookingQuestion.visible) {
					if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
						this.datastoreService.setService =
							bookingQuestion.conditionals.service_set;
					}
					if (bookingQuestion.conditionals.hasOwnProperty('resource_set')) {
						this.datastoreService.setResource =
							bookingQuestion.conditionals.resource_set;
						const selectedSuggestion = {
							resource_id: this.datastoreService.setResource,
						};
						this.datastoreService.selectedSuggestion = selectedSuggestion;
					}
					if (bookingQuestion.conditionals.hasOwnProperty('staff_set')) {
						this.datastoreService.staff_set =
							bookingQuestion.conditionals.staff_set;
						const autoSelectedStaff = {
							staff_set: this.datastoreService.staff_set,
						};
						console.log(
							`Auto-selecting staff from question (${bookingQuestion.id}): ${this.datastoreService.staff_set}`
						);
						this.datastoreService.autoSelectedStaff = autoSelectedStaff;
					}
				}

				// set client data on booking details page
				if (bookingQuestion.visible) {
					if (
						bookingQuestion.conditionals.hasOwnProperty('booker_first_name')
					) {
						this.datastoreService.booker_first_name = bookingQuestion.id;
					}
					if (bookingQuestion.conditionals.hasOwnProperty('booker_last_name')) {
						this.datastoreService.booker_last_name = bookingQuestion.id;
					}
					if (bookingQuestion.conditionals.hasOwnProperty('booker_email')) {
						this.datastoreService.booker_email = bookingQuestion.id;
					}
					if (bookingQuestion.conditionals.hasOwnProperty('booker_phone')) {
						this.datastoreService.booker_phone = bookingQuestion.id;
					}
				}

				if (bookingQuestion.conditionals.hasOwnProperty('continuebutton')) {
					// showContinueButton
					let conditionalQuestion = this.companyQuestionsForm.get(
						`${Object.keys(bookingQuestion.conditionals.continuebutton)[0]}`
					);
					if (conditionalQuestion && conditionalQuestion.value != null) {
						if (
							conditionalQuestion.value ||
							conditionalQuestion.value.length > 0
						) {
							if (
								Object.values(
									bookingQuestion.conditionals.continuebutton
								)[0][0] == '*'
							) {
								// wildcard
								if (
									conditionalQuestion.value ||
									conditionalQuestion.value.length > 0
								) {
									if (this.config['auto_select_service']) {
										this.showContinueButton = true;
									} else {
										// filter services
										if (this.datastoreService.setService) {
											this.filteredServiceList = this.servicesList.filter(
												(service) =>
													`${service.id}` ==
													`${this.datastoreService.setService}`
											);
										} else {
											this.filteredServiceList = this.servicesList;
										}
										this.showServices = true;
									}
								}
							} else {
								if (
									conditionalQuestion.value ==
									Object.values(
										bookingQuestion.conditionals.continuebutton
									)[0][0]
								) {
									if (this.config['auto_select_service']) {
										this.showContinueButton = true;
									} else {
										// filter services
										if (this.datastoreService.setService) {
											this.filteredServiceList = this.servicesList.filter(
												(service) =>
													`${service.id}` ==
													`${this.datastoreService.setService}`
											);
										} else {
											this.filteredServiceList = this.servicesList;
										}
										this.showServices = true;
									}
								}
							}
						}
					}
				}

				if (!this.datastoreService.adminJourney && admin_only) {
					bookingQuestion.visible = false;
				}

				if (!bookingQuestion.original_name) {
					bookingQuestion.original_name = bookingQuestion.name; // store old name
				}

				// if question name contains braces
				if (
					bookingQuestion.original_name &&
					/{.*?}/.test(bookingQuestion.original_name) // check if it has {placeholders}
				) {
					bookingQuestion.name = bookingQuestion.original_name.replace(
						/{(.*?)}/g,
						(placeholder, refKey) => {
							const refQuestion = bookingQuestions.find(
								(q) => q.question_reference === refKey && q.answer
							);

							if (refQuestion && refQuestion.answer) {
								return refQuestion.answer;
							}

							// If no match, keep the original {placeholder}
							return placeholder;
						}
					);
				}

				if (!bookingQuestion.visible) {
					let conditionalQuestion = this.companyQuestionsForm.get(
						`${bookingQuestion.id}`
					);
					conditionalQuestion.reset();
					conditionalQuestion.clearValidators();
					conditionalQuestion.updateValueAndValidity();

					// clear datesplit too if question is a date
					if (bookingQuestion.detail_type === 'date') {
						bookingQuestion.dateSplit = { y: '', m: '', d: '' };
					}
				}

				if (this.showServices) {
					// prechecks for continue button
					if (bookingQuestion.aws_lookup) {
						// any lookups

						let conditionalQuestion = this.companyQuestionsForm.get(
							`${bookingQuestion.lookup_field}`
						);
						if (bookingQuestion.lookedup_value == conditionalQuestion.value) {
							return; // we already looked this answer up once, dont bother again for former schema changes
						}
						let response = await this.apiService.lookupReference(
							bookingQuestion.aws_table,
							bookingQuestion.field,
							conditionalQuestion.value
						);
						// 1 = found
						// 2 = no data
						// 3 = error
						bookingQuestion.lookedup_value = conditionalQuestion.value;
						console.log('custom_response_code', response['reference']);
						if (response['custom_response_code'] == 1) {
							this.datastoreService.reference = response['reference'];
							this.lookupError = false;
							this.companyQuestionsForm
								.get(`${bookingQuestion.id}`)
								.setErrors(null);
							return 'checked';
						} else {
							// set the form control to invalid
							this.companyQuestionsForm
								.get(`${bookingQuestion.id}`)
								.setErrors({ incorrect: true });
							this.companyQuestionsForm
								.get(`${bookingQuestion.id}`)
								.markAsTouched();
							this.lookupError = true;
							return 'checked';
						}
					}
				}
			} else {
				bookingQuestion.visible = true;
			}
		});
		*/
	}

	async awsLookup(question: any): Promise<void> {
		question.lookupUsed = false;
		question.lookupError = false;
		question.searching = true;
		question.duplicateError = false;
		const conditionalQuestion = this.companyQuestionsForm.get(`${question.id}`);
		conditionalQuestion.setErrors(null);
		conditionalQuestion.markAsTouched();

		// if the conditionalQuestion is undefined return
		if (conditionalQuestion == undefined) {
			this.onQuestionChange();
			return;
		}
		// if the conditionalQuestion value is blank return
		if (conditionalQuestion.value == null || conditionalQuestion.value == '') {
			const control = this.companyQuestionsForm.get(`${question.id}`);
			control.setErrors({ incorrect: true });
			control.markAsTouched();
			question.searching = false;
			this.onQuestionChange();
			return;
		}

		const matchArray = question.conditionals.lookup.match;

		const homeOfficeQuestionId = matchArray[0].form_field;
		const homeOfficeQuestion = this.companyQuestionsForm.get(
			`${homeOfficeQuestionId}`
		);

		const nameQuestionId = matchArray[1].form_field;
		const nameQuestion = this.companyQuestionsForm.get(`${nameQuestionId}`);

		const nameValue = nameQuestion.value;
		const homeOfficeValue = homeOfficeQuestion.value;

		// add the home office question value to the checkedLookups array
		const alreadyExists = this.checkedLookups.some(
			(item) => item.name === nameValue && item.homeOffice === homeOfficeValue
		);

		if (alreadyExists) {
			console.log('Already in array:', nameValue);
			const control = this.companyQuestionsForm.get(`${question.id}`);
			control.setErrors({ incorrect: true });
			control.markAsTouched();
			question.searching = false;
			question.duplicateError = true;
			this.onQuestionChange();
			return;
		} else {
			this.checkedLookups.push({
				name: nameValue,
				homeOffice: homeOfficeValue,
			});
		}

		const response = await this.apiService.lookupReference(
			question.aws_table,
			matchArray[0].dynamodb_field,
			homeOfficeQuestion.value,
			matchArray[1].dynamodb_field,
			nameQuestion.value
		);
		// 1 = found
		// 2 = no data
		// 3 = error
		question.searching = false;
		console.log('custom_response_code', response['reference']);
		const usedCode = response['reference']?.used;

		if (usedCode) {
			const control = this.companyQuestionsForm.get(`${question.id}`);
			control.setErrors({ incorrect: true });
			control.markAsTouched();
			question.lookupUsed = true;
			this.onQuestionChange();
			return;
		}

		question.lookedup_value = conditionalQuestion.value;
		question.searching = false;
		this.datastoreService.reference = response['reference'];
		if (response['custom_response_code'] == 1) {
			if (
				response['reference'].name.toLowerCase() !==
				nameQuestion.value.toLowerCase()
			) {
				console.warn('Name does not match the reference name');
				// if the name does not match, set the form control to invalid
				const control = this.companyQuestionsForm.get(`${question.id}`);
				control.setErrors({ incorrect: true });
				control.markAsTouched();
				question.lookupError = true;
				this.onQuestionChange();
				return;
			}
			question.lookupResponse = response['reference'];
			const control = this.companyQuestionsForm.get(`${question.id}`);
			control.setErrors(null);
			this.onQuestionChange();
			return;
		} else {
			const control = this.companyQuestionsForm.get(`${question.id}`);
			control.setErrors({ incorrect: true });
			control.markAsTouched();
			question.lookupError = true;
			this.onQuestionChange();
			return;
		}
	}

	isValidDate(dateString: string): boolean {
		// Attempt to create a Date object from the dateString
		const date: Date = new Date(dateString);

		// Check if the created Date object is valid and its string representation matches the input
		return (
			date instanceof Date &&
			!isNaN(date.getTime()) &&
			date.toISOString().slice(0, 10) === dateString
		);
	}

	evaluateORCondition(condition: string, answer: any): boolean {
		const parts = condition.split(' OR ').map((p) => p.trim());

		if (Array.isArray(answer)) {
			return parts.some((part) => answer.includes(part));
		} else {
			return parts.some((part) => part === answer);
		}
	}

	// Function to evaluate custom condition
	evaluateCondition(condition, answer) {
		// Split the condition into individual parts
		const parts = condition.split(' and ');

		// Evaluate each part of the condition
		for (const part of parts) {
			// Split the part into operator and threshold
			let [operator, thresholdStr] = part.split(' ');
			const threshold = parseFloat(thresholdStr);

			// decode html entity
			operator = he.decode(operator);

			if (this.isValidDate(answer)) {
				answer = moment(answer).diff(moment(), 'days') + 1;
			}

			// Perform the comparison based on the operator
			switch (operator) {
				case '<':
					if (!(parseFloat(answer) < threshold)) {
						return false; // If any part is false, the entire condition is false
					}
					break;
				case '<=':
					if (!(parseFloat(answer) <= threshold)) {
						return false;
					}
					break;
				case '>':
					if (!(parseFloat(answer) > threshold)) {
						return false;
					}
					break;
				case '>=':
					if (!(parseFloat(answer) >= threshold)) {
						return false;
					}
					break;
				case '=':
					if (!(parseFloat(answer) === threshold)) {
						return false;
					}
					break;
				default:
					return false;
			}
		}

		// If all parts pass, return true
		return true;
	}

	// addHyperlinks(question) {
	//   let linkPattern = /#(.*?)#/g;
	//   if (linkPattern.test(question.conditionals.component_text)) {
	//     // replace the #link# with a hyperlink
	//     question.conditionals.component_text =
	//       question.conditionals.component_text.replace(
	//         linkPattern,
	//         function (match, p1) {
	//           return (
	//             `<a href="${question.conditionals.hyperlink}" target="_blank">` +
	//             p1 +
	//             '</a>'
	//           );
	//         }
	//       );
	//   }
	//   return question.conditionals.component_text;
	// }

	addHyperlinks(text: string): string {
		return text.replace(/~(.*?)~/g, (match, p1) => {
			const decoded = this.decodeHtmlEntities(p1);
			return `<a ${decoded}</a>`;
		});
	}

	setAddress(event, question) {
		const selectedValue = event.target.value;

		if (
			selectedValue === '' ||
			selectedValue === 'undefined' ||
			selectedValue === undefined
		) {
			// reset the address field
			this.companyQuestionsForm.controls[question.reference].setValue('');
			this.datastoreService.selectedAddress = '';
			question.is_within_borough = false;
			question.eligible_address = {};
			this.onQuestionChange();
			return;
		}

		const selectedAddress = question.addresses.find(
			(opt) => opt.address.full_address === selectedValue
		)?.address;

		this.companyQuestionsForm.controls[question.reference].setValue(
			selectedAddress.full_address
		);
		this.datastoreService.selectedAddress = selectedAddress.full_address;
		question.is_within_borough = selectedAddress.is_within_borough;
		// const custodianCodeArray = question.conditionals.os_places.custodian_codes;

		if (question.is_within_borough) {
			// custodian code matches
			question.eligible_address = {
				[question.id]: 'eligible_address',
			};
		} else {
			question.eligible_address = {
				[question.id]: 'ineligible_address',
			};
		}

		this.onQuestionChange();
	}

	getAddress(question) {
		question.badPostcode = false;
		const postcode: string = this.companyQuestionsForm.controls[
			'postcode_' + question.reference
		].value.replace(/\s/g, '');
		// Custom error handling for postcode

		//regex from certitificate ordering
		const pattern = new RegExp(
			/^([Gg][Ii][Rr] 0[Aa]{2}|((([A-Za-z][0-9]{1,2})|([A-Za-z][A-HJ-Ya-hj-y][0-9]{1,2})|([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-HJ-Ya-hj-y][0-9]?[A-Za-z]))\s?[0-9][A-Za-z]{2}))$/
		);
		if (pattern.test(postcode)) {
			this.apiService.get(postcode).subscribe(
				(res) => {
					const object: any = res;
					if (object.results) {
						const addresses = object.results;
						question.addresses = [];
						if (addresses.length > 1) {
							// If it matches up, push the addresses
							addresses.forEach((item) => {
								// if (item.DPA) {
								// 	question.addresses.push({ address: item.DPA });
								// } else {
								// 	question.addresses.push({ address: item.LPI });
								// }
								console.log(item);
								question.addresses.push({ address: item });
							});
						}
					}

					// reset the address field
					this.companyQuestionsForm.controls[question.reference].setValue('');
					this.datastoreService.selectedAddress = '';
					question.is_within_borough = false;
					question.eligible_address = {};
					this.onQuestionChange();

					this.spinner.hide();
				},
				(err) => {
					console.log(err);
					this.spinner.hide();
				}
			);
		} else {
			question.badPostcode = true;
		}
	}

	// Go back to the booking details page
	routerGoBack() {
		// If location is before services then redirect back to locations else redirect back to departments
		this.router.navigate(['/departments']);
	}

	restartJourney() {
		if (sessionStorage.getItem('journey')) {
			this.router.navigate(['start/' + this.journey]);
		} else {
			this.router.navigate(['/departments']);
		}
	}

	async ngOnInit() {
		this.libFormBuilderService.processing$.subscribe((isProcessing) => {
			if (isProcessing) {
				this.spinner.show();
			} else {
				this.spinner.hide();
			}
		});

		this.adminOnlyJourney = this.datastoreService.adminJourney;

		this.agentMode = localStorage.getItem('agent');

		this.route.params.subscribe(async (params) => {
			if (params['journey']) {
				console.log('jrni!', params['journey']);
				sessionStorage.setItem('journey', params['journey']);
			}
			try {
				this.spinner.show();

				let configCompanyId = AppConfig.settings.core.company_id;
				if (this.datastoreService.isCitizenshipRoute) {
					configCompanyId = AppConfig.settings.core.citizenship_company_id;
				}

				const _config: any = await this.apiService.getConfig(configCompanyId);
				this.datastoreService.config = _config;

				this.returnConfig =
					_config.journey_config.appointments.returnHomeButtonLink;

				const appConfig: any = await this.apiService.getConfig();
				appConfig.first_page_questions_to_ignore =
					_config.journey_config.appointments.first_page_questions_to_ignore;
				this.configService.setConfig(appConfig);
				this.spinner.hide();
				this.loadedConfig = true;
				this.config = await this.apiService.getConfig();

				this.companyId = _config.company;
				this.suggestions = [];
				this.journey = sessionStorage.getItem('journey');
				if (this.journey !== 'default') {
					const appointmentTypes =
						this.config.journey_config.appointments[
						'appointment_types_dropdown'
						];
					const normalize = (str: string) =>
						str.toLowerCase().replace(/\s+/g, '_');
					const appointmentType = appointmentTypes.find(
						(type) => normalize(type.name) == this.journey
					);
					if (appointmentType) {
						this.initQuestions.controls['type_of_appointment'].setValue(
							appointmentType.form_schema
						);
						this.validateAppointmentTypeQuestion();

						// Restore form-builder answers when navigating back in the journey.
						// Reads from form_builder_answers sessionStorage (form-builder's own
						// persistence, keyed by schema ID) so answers survive the datastore
						// reset that happens later in this ngOnInit.
						const storedAnswers = JSON.parse(sessionStorage.getItem('form_builder_answers') || '{}');
						const schemaId = appointmentType.form_schema;
						if (storedAnswers[schemaId] && Object.keys(storedAnswers[schemaId]).length > 0) {
							this.formData = { ...storedAnswers[schemaId] };
						}
					} else {
						this.initQuestions.controls['type_of_appointment'].setValue('');
						this.journey == undefined;
					}
				}
				if (this.journey == undefined) {
					this.journey = 'default';
					this.initQuestions.controls['type_of_appointment'].setValue('');

					const content =
						_config?.journey_config?.appointments?.page_content?.[this.journey];

					sessionStorage.setItem('journey', this.journey);
					this.datastoreService.pageContent = content;
				}
			} catch (err) {
				console.log(err);
				this.spinner.hide();
			}

			if (this.adminOnlyJourney) {
				const dropdown =
					this.config.journey_config.appointments['appointment_types_dropdown'];

				const adminOptions = [
					{
						name: '(Admin) Citizenships',
						admin_only: true,
						agent_only: true,
						form_schema: 'admin-citizenship',
					},
					{
						name: '(Admin) Certificate',
						admin_only: true,
						agent_only: true,
						form_schema: 'admin-certificate',
					},
				];

				adminOptions.forEach((adminOption) => {
					const alreadyExists = dropdown.some(
						(opt) =>
							opt.name === adminOption.name &&
							opt.form_schema === adminOption.form_schema
					);

					if (!alreadyExists) {
						dropdown.push(adminOption);
					}
				});
			} else {
				this.config.journey_config.appointments['appointment_types_dropdown'] =
					this.config.journey_config.appointments[
						'appointment_types_dropdown'
					].filter((item) => !item.admin_only);
			}

			if (this.agentMode) {
				this.config.journey_config.appointments['appointment_types_dropdown'] =
					this.config.journey_config.appointments[
						'appointment_types_dropdown'
					].filter((item) => item.agent_only);
			}

			this.updateWithStoredAnswers();

			this.datastoreService.bookingForm = null;
			this.datastoreService.companyQuestionsForm = null;
			this.datastoreService.selectedDate = null;
			this.datastoreService.selectedSlot = null;
			this.availabilityService.setSelectedSlot(null);
			this.scrollToTop();
			this.spinner.show();

			// Use this.departmentService.getLocation() if the services are set on the children departments
			// Use this.departmentService.get() if the services are set on the parent department
			this.departmentService.get().then(
				(selectedDepartment) => {
					if (selectedDepartment === undefined) {
						this.restartJourney();
					} else {
						this.selectedDepartment = selectedDepartment;

						// Get the configurable data
						if (this.selectedDepartment.hasOwnProperty('extra')) {
							// Set the extra text on the page to the text taken from the business question
							this.selectedDepartment.extra.hasOwnProperty('services_page_text')
								? (this.servicePageText =
									this.selectedDepartment.extra.services_page_text)
								: null;
							this.selectedDepartment.extra.hasOwnProperty(
								'service_guidance_text'
							)
								? (this.guidanceText =
									this.selectedDepartment.extra.service_guidance_text)
								: null;
						}

						// Get the available services on the selected department
						this.servicesService
							.getServices(selectedDepartment)
							.then((services) => {
								this.memberService.getMember().then(
									(member) => {
										this.servicesList = services;
										services.forEach((service, index) => {
											// service.$getImages().then((image) => {
											//   service.image = image[0];
											//   this.cdref.detectChanges();
											// });
										});
										this.spinner.hide();
									},
									(err) => {
										this.alertService.error(
											this.translateService.instant('COMMON.GENERAL_ERR')
										);
										this.spinner.hide();
									}
								);
							});
					}
				},
				(err) => {
					this.alertService.error(
						this.translateService.instant('COMMON.GENERAL_ERR')
					);
					this.spinner.hide();
				}
			);
		});
	}

	updateWithStoredAnswers() {
		// When the user navigates back to this page, restore the dropdown selection
		// and form-builder answers. datastoreService.selectedSchema is the schema ID
		// set by validateAppointmentTypeQuestion when the user originally picked an
		// option; datastoreService.type_of_appointment is never assigned (legacy field).
		const schemaId = this.datastoreService.selectedSchema;
		if (!schemaId) return;

		if (this.initQuestions.get('type_of_appointment').value === schemaId) return;

		// Pre-load form-builder answers BEFORE forceRecreateFormBuilder fires so the
		// [formData] input is populated when <lib-form-builder> renders.
		const storedAnswers = JSON.parse(sessionStorage.getItem('form_builder_answers') || '{}');
		if (storedAnswers[schemaId] && Object.keys(storedAnswers[schemaId]).length > 0) {
			this.formData = { ...storedAnswers[schemaId] };
		}

		this.initQuestions.get('type_of_appointment').setValue(schemaId);
		this.validateAppointmentTypeQuestion();
		this.spinner.hide();
	}

	validateQuestions(event, question) {
		if (question.detail_type === 'date') {
			// Extract the day, month, and year values from the inputs
			const dayInput = question.dateSplit.d;
			const monthInput = question.dateSplit.m;
			const yearInput = question.dateSplit.y;

			// console.log(question);

			// Combine them into a single date string
			const day = dayInput?.padStart(2, '0'); // Ensure day is two digits
			const month = monthInput?.padStart(2, '0'); // Ensure month is two digits
			const year = yearInput; // Year doesn't need padding

			// Validate that the inputs are valid and combine into a date
			if (day && month && year?.length === 4) {
				this.companyQuestionsForm.controls[question.reference].markAsTouched();
				this.companyQuestionsForm.controls[question.reference].markAsDirty();
				const combinedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD
				if (this.isValidDateQuestion(combinedDate)) {
					this.companyQuestionsForm.controls[question.reference].setValue(
						combinedDate
					);

					if (question.cap_calendar_dates_one_year_from_entered_date) {
						this.datastoreService.dateCapInitDate = question.dateSplit;
						console.log(
							`Calendar cap date set from question ${question.id}`,
							this.datastoreService.dateCapInitDate
						);
					}
				} else {
					console.error('Invalid date entered:', combinedDate);
					// Set the form control to invalid
					this.companyQuestionsForm
						.get(`${question.reference}`)
						.setErrors({ invalid_date: true });
				}
			} else {
				// if the day is not a number,
				// or if its not between 1 and 31,
				// or if month is not a number or not between 1 and 12,
				// or if year is not a number or not 4 digits
				if (
					!day ||
					isNaN(Number(day)) ||
					Number(day) < 1 ||
					Number(day) > 31 ||
					!month ||
					isNaN(Number(month)) ||
					Number(month) < 1 ||
					Number(month) > 12 ||
					!year ||
					!/^\d{4}$/.test(year) // Check if year is a 4-digit number
				) {
					// console.error('Invalid date input:', { day, month, year });
					// Set the form control to invalid
					this.companyQuestionsForm
						.get(`${question.reference}`)
						.setErrors({ invalid_date: true });
				}

				this.companyQuestionsForm.controls[question.reference].setValue('');
			}
		}

		if (question.id === 34299) {
			if (event.target.selectedIndex > 0) {
				this.answeredQuestions[0] = true;
			} else {
				this.answeredQuestions[0] = false;
			}
		}
		if (question.id === 276) {
			if (event.target.selectedIndex > 0) {
				this.answeredQuestions[1] = true;
			} else {
				this.answeredQuestions[1] = false;
			}
		}
		if (question.id === 278) {
			if (event.source._checked === true) {
				this.answeredQuestions[2] = true;
				this.ageType = event.source._value;
			} else {
				this.answeredQuestions[2] = false;
			}
		}
		// this.calculateVisibility();
		this.onQuestionChange();
	}

	isValidDateQuestion(dateString: string): boolean {
		const date = new Date(dateString);
		return !isNaN(date.getTime()); // Check if the date is valid
	}

	updateRadio(form, question, answer) {
		form.controls[question].reset();
		form.controls[question].clearValidators();
		form.controls[question].updateValueAndValidity();
		this.onQuestionChange();
		this.searchText = '';
		this.suggestions = [];
		// crappy fix for updating radios for https://bookinglab.atlassian.net/browse/EMS-739
		// need to find a better way when time allows
		form.controls[question].setValue(answer);
		this.onQuestionChange();
	}

	selectService(service: any = undefined) {
		this.spinner.show();
		let selectedService;
		if (this.serviceToSet) {
			selectedService = this.serviceToSet;
		} else {
			if (service) {
				selectedService = service;
			} else {
				selectedService = this.filteredServiceList[0];
			}
		}

		console.log('Selected service:', selectedService);

		this.selectedService = selectedService;
		this.servicesService.selectedService = selectedService;
		// if (this.companyQuestionsForm.invalid) {
		//   this.scrollToTop();
		//   this.spinner.hide();
		//   this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
		//   return;
		// }
		const answeredQuestions = this.companyQuestions;
		// loop over the questions and find the ones with aws_lookup "true", filter out ones without an answer
		for (const bookingQuestion of answeredQuestions) {
			if (bookingQuestion.aws_lookup) {
				this.datastoreService.lookupResponses.push(
					bookingQuestion.lookupResponse
				);
			}
		}

		console.log(this.datastoreService.lookupResponses);
		// save the reference to the datastore for later use
		// this.datastoreService.companyQuestionsForm = this.companyQuestionsForm;

		if (!this.config['auto_select_service']) {
			this.continue();
		}
	}

	onFileUpload(event: Event, bookingQuestion: any): void {
		const input = event.target as HTMLInputElement;
		if (!input.files || input.files.length === 0) return;

		const file = input.files[0];
		const reader = new FileReader();

		reader.onload = () => {
			const base64 = reader.result as string;

			// Find and set the value of the related form control
			const control = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
			if (control) {
				control.setValue(base64);
			}
		};

		reader.onerror = (err) => {
			console.error('File read error:', err);
		};

		reader.readAsDataURL(file);
	}

	continue() {
		this.spinner.show();
		let canContinue = true;
		console.log('reference', this.datastoreService);
		if (this.datastoreService.reference) {
			const requiredByDate = moment(
				this.datastoreService.reference?.required_by_date
			);
			if (moment().isSameOrAfter(requiredByDate)) {
				canContinue = false;
				this.citizenshipExpired = true;
			}
		}
		if (canContinue) {
			const selectedSchema = this.datastoreService.selectedSchema;
			const formBuilderAnswers = JSON.parse(sessionStorage.getItem('form_builder_answers') || '{}');

			// Re-derived on every pass: the customer can come back and change either answer.
			this.datastoreService.familyCitizenshipBooking = false;
			this.datastoreService.groupCitizenshipBooking = false;

			if (formBuilderAnswers[selectedSchema].hasOwnProperty('how_many_attendees_and_their_details_including_if_adult_or_child')) {
				console.log('how_many_attendees_and_their_details_including_if_adult_or_child', formBuilderAnswers[selectedSchema]['how_many_attendees_and_their_details_including_if_adult_or_child']);
				if (formBuilderAnswers[selectedSchema]['how_many_attendees_and_their_details_including_if_adult_or_child']) {
					this.datastoreService.familyCitizenshipBooking = true;
					console.log('familyCitizenshipBooking', this.datastoreService.familyCitizenshipBooking);
				}

			}
			if (formBuilderAnswers[selectedSchema].hasOwnProperty('what_type_of_ceremony_are_you_booking')) {
				console.log('what_type_of_ceremony_are_you_booking', formBuilderAnswers[selectedSchema]['what_type_of_ceremony_are_you_booking']);
				if (
					formBuilderAnswers[selectedSchema]['what_type_of_ceremony_are_you_booking'] === 'group'
				) {
					this.datastoreService.groupCitizenshipBooking = true;
					console.log('groupCitizenshipBooking', this.datastoreService.groupCitizenshipBooking);
				}

			}
			if (this.selectedService) {
				this.servicesService.set(this.selectedService);
				// backup the service so that if we switch to the alt company we have a way to swtich back
				this.datastoreService.selectedService = this.selectedService;

				if (this.companyQuestionsForm.controls['babys_date_of_birth']) {
					const dobCtrl = this.companyQuestionsForm.controls['babys_date_of_birth'];
					if (dobCtrl.value) {
						this.datastoreService.childDob = dobCtrl.value;
					}
				} else if (formBuilderAnswers[selectedSchema]?.['babys_date_of_birth']) {
					this.datastoreService.childDob = formBuilderAnswers[selectedSchema]['babys_date_of_birth'];
				}

				// The calendar caps notice appointments at 29 days before the ceremony
				// (BRPO-66), so it needs the date answered here. Read it only while the
				// couple say they know their date: the form builder keeps the answer of a
				// hidden field, so a date answered and then withdrawn would otherwise go
				// on capping the calendar.
				const knowsCeremonyDate =
					this.companyQuestionsForm.controls['do_you_know_the_date_of_your_ceremony']?.value ||
					formBuilderAnswers[selectedSchema]?.['do_you_know_the_date_of_your_ceremony'];
				this.datastoreService.ceremonyDate =
					knowsCeremonyDate === 'yes'
						? this.companyQuestionsForm.controls['when_is_your_ceremony']?.value ||
							formBuilderAnswers[selectedSchema]?.['when_is_your_ceremony']
						: undefined;
				// if (this.companyQuestionsForm.controls['date_of_death']) {
				//   const dobCtrl = this.companyQuestionsForm.controls['date_of_death'];
				//   this.datastoreService.deathDate = dobCtrl.value;
    //   		 } else if (formBuilderAnswers[selectedSchema]?.['date_of_death']) {
				// 	this.datastoreService.deathDate = formBuilderAnswers[selectedSchema]['date_of_death'];
				// }

				// if (this.companyQuestionsForm.controls['']) {
				//   const dobCtrl = this.companyQuestionsForm.controls[''];
				//   if (dobCtrl.value) {
				//     this.datastoreService.mccdRegDate = dobCtrl.value;
				//   }
				// }

				// if (this.companyQuestionsForm.controls['']) {
				//   const dobCtrl = this.companyQuestionsForm.controls[''];
				//   if (dobCtrl.value) {
				//     this.datastoreService.mccdRegDate = dobCtrl.value;
				//   }
				// }
				this.datastoreService.startQuestions = this.companyQuestionsForm;

				if (this.setCompanyFromQuestion) {
					// this.datastoreService
					this.setLocationAndResource(this.setCompanyFromQuestion);
				} else {
					if (!this.skipLocations) {
						this.router.navigate(['/locations']);
					} else {
						this.setLocationAndResource(
							this.datastoreService.selectedSuggestion.company_id
						);
					}
				}
			} else {
				this.alertService.warn('Please select a service before proceeding');

				this.scrollToTop();
			}
		} else {
			this.spinner.hide();
			this.showServices = false;
		}
	}

	setLocationAndResource(companyIdToSelect) {
		this.departmentService.get().then(
			async (selectedDepartment) => {
				this.locations = null;
				this.datastoreService.locations = null;
				this.selectedDepartment = selectedDepartment;

				// Get the children departments (locations) from the selected department
				await this.departmentService
					.getSelectedDepartmentChildren(
						this.selectedDepartment.id,
						this.servicesService.selectedService.id
					)
					.then(
						async (locations) => {
							await this.departmentService
								.setLocationList(locations)
								.then(async (filteredLocations) => {
									// await filteredLocations.forEach((tempLocation: any) => {
									//   tempLocation.$getAddress().then((res) => {
									//     tempLocation.addresses = res;
									//   });
									// });

									filteredLocations = filteredLocations.filter(
										(selectedLocation) =>
											Number(selectedLocation.id) == Number(companyIdToSelect)
									);

									// Filter locations on the service & then display them here
									this.locations = filteredLocations;
									this.datastoreService.locations = filteredLocations;
									this.selectedLocation = this.locations[0];
									this.continueSkip();
									this.spinner.hide();
								});
						},
						(err) => {
							console.error(err);
							this.alertService.error(
								this.translateService.instant('COMMON.GENERAL_ERR')
							);
							this.spinner.hide();
						}
					);
			},
			(err) => {
				this.alertService.error(
					this.translateService.instant('COMMON.GENERAL_ERR')
				);
				this.spinner.hide();
			}
		);
	}

	continueSkip() {
		// Use this.departmentService.getLocation() if the services are set on the children departments
		// Use this.departmentService.get() if the services are set on the parent department
		this.departmentService.get().then((location) => {
			if (this.selectedLocation) {
				if (location && location !== this.selectedLocation) {
					this.datastoreService.selectedDate = null;
					this.availabilityService.setSelectedSlot(null);
				}
				this.departmentService.setLocation(this.selectedLocation);
				// If we picked an alt company as our cmpany, change up the service and parent company
				if (
					this.selectedLocation.membership_id.toString() ===
					this.core.alt_company_id
				) {
					this.departmentService
						.getAltParentDepartment()
						.then((altDepartment) => {
							this.servicesService
								.getServices(altDepartment)
								.then((altServices) => {
									// const altService = altServices.filter(x => x.id.toString() === this.core.alt_service_id)[0]
									const altService = altServices.filter(
										(x) => x.name === this.datastoreService.selectedService.name
									)[0];

									if (altService) {
										altDepartment.extra = location.extra;
										this.datastoreService.selectedDepartment =
											this.selectedDepartment;

										this.servicesService.set(altService);
										this.departmentService.set(altDepartment);
										this.router.navigate(['/calendar']);
									} else {
										this.alertService.warn('Error loading alt department data');

										this.scrollToTop();
									}
								});
						});
				} else {
					this.router.navigate(['/calendar']);
				}
			} else {
				this.alertService.warn('Please select a location before proceeding');

				this.scrollToTop();
			}
		});
	}

	// scroll to the top of the page
	scrollToTop() {
		const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
		window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
	}

	async getCompanyQuestions() {
		this.questionsService.getCompanyQuestions(34902).subscribe((res: any) => {
			// Questions = all questions on the company
			const questions = res.questions;
			this.datastoreService.companyQuestions = questions;
			this.addQuestionsToForm(questions);
		});
	}

	async onSearch(event: KeyboardEvent, question: any): Promise<void> {
		const ignoredKeys = [
			'ArrowUp',
			'ArrowDown',
			'Enter',
			'Escape',
			'Tab',
			'Shift',
			'Control',
			'Alt',
			'Meta',
		];

		const key = event.key;

		// Skip keys that may interrupt accessibility
		if (ignoredKeys.includes(key)) {
			return;
		}

		question.selected_resource = undefined;
		this.skipLocations = false;
		question.searching = true;
		question.noResults = false;
		try {
			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(async () => {
				this.suggestions = [];
				const query = (event.target as HTMLInputElement).value;
				this.searchText = query.trim();
				if (this.searchText) {
					this.suggestions = await this.apiService.searchVenue(
						this.companyId,
						this.searchText
					);
					question.searching = false;
					if (question.filter_by) {
						// go get the question from the form from the filter_by id
						let filterControl = this.companyQuestionsForm.get(
							`${question.filter_by}`
						);
						this.suggestions = this.suggestions.filter(
							(suggestion) =>
								suggestion.venue_type.toLowerCase().trim() ==
								filterControl.value.toLowerCase().trim()
						);
					}
					if (this.suggestions.length == 0) {
						question.noResults = true;
					}
				} else {
					question.searching = false;
					this.suggestions = [];
				}
			}, 500);
		} catch (error) {
			console.log(error);
		}
	}

	clearSearch(question: any): void {
		// reset
		this.searchText = '';
		this.suggestions = [];
		question.selected_resource = null;
		question.searching = false;
		question.noResults = false;
		// clear the control value
		this.companyQuestionsForm.controls[question.id].setValue('');
		this.onQuestionChange();
	}

	selectSuggestion(suggestion: string, question: any): void {
		this.suggestions = [];
		this.searchText = suggestion['pretty_name']
			? suggestion['pretty_name']
			: suggestion['venue_name'];
		question.selected_resource = suggestion;
		this.datastoreService.selectedSuggestion = suggestion;
		if (this.autoSetLocation) {
			this.skipLocations = true;
			this.datastoreService.skipLocationsPage = true;
		}
		this.companyQuestionsForm.controls[question.id].setValue(
			suggestion['pretty_name']
		);
		this.companyQuestionsForm.controls[question.id].updateValueAndValidity();
		this.onQuestionChange();
	}

	addQuestionsToForm(questions) {
		// this.companyQuestionsForm = this.formBuilder.group({});
		for (let index = 0; index < questions.length; index++) {
			const question = questions[index];
			question.visible = false;
			question.reference = question.id;
			if (!question.admin_only) {
				if (!question.settings.hasOwnProperty('conditional_question')) {
					question.visible = false; // default hidden all
				}

				const questionControl = question.id;

				if (!question['help_text']) {
					// question without any config
					question.conditionals = {
						page: this.router.url, // show on current page
					};
				} else {
					question.conditionals = JSON.parse(question['help_text']);
				}

				if (question.conditionals['component_text']) {
					const tildePattern = /~(.*?)~/g;
					if (tildePattern.test(question.conditionals['component_text'])) {
						question.conditionals['component_text'] = question.conditionals[
							'component_text'
						].replace(tildePattern, (match, p1) => {
							const decoded = this.decodeHtmlEntities(p1);
							return `<a ${decoded}</a>`;
						});
					}
				}

				if (question.detail_type === 'date') {
					const date = this.datastoreService.startQuestions?.get(
						question.id.toString()
					)?.value;

					if (date && date.length > 0) {
						console.log(date.split('-'));
						const [y, m, d] = date.split('-');
						question.dateSplit = { y, m, d };
						console.log(question);
					} else {
						question.dateSplit = { y: '', m: '', d: '' };
					}
				}
				if (question.conditionals.page == this.router.url.replace('/', '')) {
					let validators = [];

					// required validators
					if (question.required) {
						validators.push(Validators.required);
					}
					if (question.conditionals['address_lookup']) {
						const postcodeDefaultValue =
							this.datastoreService.startQuestions?.get(
								'postcode_' + questionControl
							)?.value || '';

						this.companyQuestionsForm.addControl(
							'postcode_' + questionControl,
							new UntypedFormControl(postcodeDefaultValue, validators)
						);
						if (postcodeDefaultValue?.length > 0) {
							this.getAddress(question);
							question.eligible_address = {
								[question.id]: 'eligible_address',
							};
						}
					}

					this.companyQuestions.push(question);

					const defaultValue =
						this.datastoreService.startQuestions?.get(
							question.reference.toString()
						)?.value || '';

					if (
						question.detail_type === 'check' ||
						question.detail_type === 'check-price'
					) {
						this.companyQuestionsForm.addControl(
							questionControl,
							new UntypedFormControl(false, validators)
						);
					} else {
						this.companyQuestionsForm.addControl(
							questionControl,
							new UntypedFormControl(defaultValue, validators)
						);
					}
				}
			}
		}
		this.onQuestionChange();
	}


	updateAnswers(event: any) {
		// Handle service lookup
		if (event.setService) {
			console.log('Setting service to:', event.setService);
			const serviceToSet = this.servicesList.find(
				(service) => service.id == event.setService
			);
			if (serviceToSet) {
				this.serviceToSet = serviceToSet;
			} else {
				console.error('Service not found:', event.setService);
			}
		}

		if (event.formData) {
			this.commonFunctions.updateAnswers(event);
		}
	}

	storeSchema(schema: any) {
		this.commonFunctions.storeSchema(schema);
	}
}
